module.exports = __webpack_public_path__ + "media/bg4.289a1d95.mp3";